export default "__VITE_PUBLIC_ASSET__f85d6776__"